import './style.js';
import 'babel-polyfill'
import 'es6-map/implement'
import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'

import './Components/Header';
import './Modules/Homepage';
import './Components/PremiumUpsellPage';
import './Modules/FirefoxLearnMore';
import './Components/HomePage'

import { TransState } from './Modules/Localization'
import { LoginModalContainer } from './Modules/PremiumPage'
import { GoogleButton as AppAuthGoogleButton } from './Modules/AppAuthPage'
import { GoogleButton as SignupGoogleButton } from './Modules/SignupPage'
import { LoginPage } from './Modules/LoginPage'
import { UpdatePaymentMethodForm } from './Components/UpdatePaymentMethodForm'
import { CheckoutForm } from "./Components/CheckoutForm";
import store from './store'

import SentryBootstrapper from './sentry';

SentryBootstrapper();

import PremiumPageBootstrapper from './premium_page';
PremiumPageBootstrapper();


const apps = [
  {
    id: 'login-page-login-container',
    element: <LoginPage />,
  },
  {
    id: 'auth-app-google',
    element: <AppAuthGoogleButton />,
  },
  {
    id: 'signup-page-google-button',
    element: <SignupGoogleButton />,
  },
  {
    id: 'premium-auth-modal-container',
    element: <LoginModalContainer />,
  },
  {
    id: 'update-payment-method-container',
    element: <UpdatePaymentMethodForm />,
  },
  {
    id: 'premium-payment-form',
    element: <CheckoutForm />,
  }
];

const loadApps = () => {
  apps.forEach(({id, element}) => {
    const el = document.getElementById(id);

    if (el) {
      ReactDOM.render(
        <Provider store={store}>
          <TransState>{ element }</TransState>
        </Provider>
        , el
      )
    }
  })
};

document.addEventListener('DOMContentLoaded', loadApps);
